import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormLabel,
  Grid,
  TextField,
} from "@mui/material";
import React, { useCallback, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import SendIcon from "@mui/icons-material/Send";
import DialogAttachmentManager from "../../../../Globals/DialogAttachmentManager";
import { useCookies } from "react-cookie";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import api from "../../../../../Apis";

const TrainingBotAIDialog = ({ isOpen, onClose, fetchTrainingHistory }) => {
  const { ai_id } = useParams();
  const { t } = useTranslation();
  const [cookies] = useCookies("is_login");
  const [state, setState] = useState({
    is_open_dialog_file_manager: false,
    attachments: [],
  });
  const {
    control,
    formState: { errors },
    reset,
    watch,
    handleSubmit,
  } = useForm({
    mode: "onChange",
  });

  const onSubmit = useCallback(
    async (values) => {
      // if (state.fanpage_selected.length === 0 && state.selected_group_fanpage.length === 0) {
      //   Swal.fire({
      //     icon: "warning",
      //     text: "Vui lòng chọn fanpage hoặc nhóm fanpage",
      //   });
      //   return;
      // }

      // if (!embedModelSelected) {
      //   Swal.fire({
      //     icon: "warning",
      //     text: "Vui lòng chọn model dạy AI",
      //   });
      //   return;
      // }

      try {
        const body = {
          text: "Hỏi: " + values.text + "\nTrả lời: " + values.answer,
          fanpage_ids: [],
          attachments: state.attachments.map((item) => item.url),
          model: null,
          group_ids: [],
          ai_bot_id: ai_id,
        };
        setState((prevState) => ({ ...prevState, isLoading: true }));

        const res = await fetch(api.gpt_assistant_create_vector, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookies.is_login}`,
          },
          body: JSON.stringify(body),
        });

        const data = await res.json();

        if (data?.success) {
          Swal.fire({
            icon: "success",
            text: data?.message,
          });
          fetchTrainingHistory(1);
          reset();
          setState((prevState) => ({
            ...prevState,
            attachments: [],
            selected_group_fanpage: [],
          }));
        } else {
          Swal.fire({
            icon: "error",
            title: t("common.message.error"),
            text: data?.message || t("common.message.pleaseTryAgain"),
          });
        }
      } catch (error) {
        console.error("Submit error:", error);
        Swal.fire({
          icon: "error",
          title: t("common.message.error"),
          text: t("common.message.pleaseTryAgain"),
        });
      } finally {
        setState((prevState) => ({ ...prevState, isLoading: false }));
      }
    },
    [
      // state.fanpage_selected,
      // state.selected_group_fanpage,
      state.attachments,
      cookies.is_login,
      t,
      reset,
      ai_id,
      fetchTrainingHistory
    ]
  );

  const updateImagePicked = useCallback((images) => {
    setState((prevState) => ({
      ...prevState,
      attachments: images,
    }));
  }, []);

  const removeAttachment = useCallback((index) => {
    setState((prevState) => ({
      ...prevState,
      attachments: prevState.attachments.filter((_, i) => i !== index),
    }));
  }, []);

  return (
    <React.Fragment>
      <Dialog fullWidth={true} maxWidth="lg" open={isOpen} onClose={onClose}>
        <DialogTitle>Huấn luyện Bot AI</DialogTitle>
        <DialogContent>
          <div style={{ marginTop: "20px" }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* Ô THỨ NHẤT: NỘI DUNG KHÁCH HỎI */}
              <Box sx={{ mb: 2 }}>
                <FormLabel
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    display: "block",
                    color: "#333",
                  }}
                >
                  1. Nội dung khách hỏi:
                </FormLabel>
                <Controller
                  control={control}
                  name="text"
                  defaultValue=""
                  rules={{
                    required: {
                      value: true,
                      message: "Nội dung khách hỏi không được để trống",
                    },
                  }}
                  render={({ field }) => (
                    <textarea
                      {...field}
                      placeholder="Nhập nội dung khách hỏi..."
                      className="form-control"
                      rows={5} // Chiều cao vừa phải
                      style={{ resize: "none" }}
                      // onChange={(e) => {
                      //   field.onChange(e);
                      //   // Tính toán token: Lấy giá trị ô này + giá trị hiện tại của ô 'answer' trong form
                      //   const currentAnswer = watch("answer") || "";
                      //   const tokens = enc.encode(e.target.value + currentAnswer).length;
                      //   setTokenCount(tokens);
                      // }}
                    />
                  )}
                />
                {errors.text && (
                  <p style={{ color: "red", mt: "5px", fontSize: "14px" }}>
                    {errors.text.message}
                  </p>
                )}
              </Box>

              {/* Ô THỨ HAI: NỘI DUNG AI TRẢ LỜI */}
              <Box sx={{ mb: 2 }}>
                <FormLabel
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    display: "block",
                    color: "#333",
                  }}
                >
                  2. Nội dung AI trả lời:
                </FormLabel>
                <Controller
                  control={control}
                  name="answer" // Tên field mới
                  defaultValue=""
                  rules={{
                    required: {
                      value: true,
                      message: "Nội dung trả lời không được để trống",
                    },
                  }}
                  render={({ field }) => (
                    <textarea
                      {...field}
                      placeholder="Nhập nội dung bạn muốn AI trả lời mẫu..."
                      className="form-control"
                      rows={8} // Chiều cao ngắn hơn ô trên
                      style={{ resize: "none" }}
                      // onChange={(e) => {
                      //   field.onChange(e);
                      //   // Tính toán token: Lấy giá trị ô này + giá trị hiện tại của ô 'text' (khách hỏi)
                      //   const currentQuestion = watch("text") || "";
                      //   const tokens = enc.encode(currentQuestion + e.target.value).length;
                      //   setTokenCount(tokens);
                      // }}
                    />
                  )}
                />
                {errors.answer && (
                  <p style={{ color: "red", mt: "5px", fontSize: "14px" }}>
                    {errors.answer.message}
                  </p>
                )}
              </Box>

              {/* PHẦN ĐÍNH KÈM FILE */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "12px",
                  gap: "20px",
                }}
              >
                <Button
                  onClick={() =>
                    setState({ ...state, is_open_dialog_file_manager: true })
                  }
                  type="button"
                  className="text-transform"
                  variant="contained"
                  color="warning"
                  startIcon={<AddRoundedIcon />}
                >
                  {"Đính kèm ảnh/video khi AI trả lời"}
                </Button>
              </Box>

              {/* DANH SÁCH FILE ĐÃ CHỌN */}
              <Box sx={{ marginTop: "12px" }}>
                {state.attachments.map((item, i) => (
                  <Grid container spacing={2} key={i}>
                    <Grid item xs={10}>
                      <TextField
                        sx={{ marginBottom: "15px" }}
                        autoComplete="off"
                        size="small"
                        fullWidth
                        label={`Link ảnh thứ ${i + 1}`}
                        variant="outlined"
                        value={item.url}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Button
                        onClick={() => removeAttachment(i)}
                        variant="contained"
                        color="error"
                        size="medium"
                      >
                        {t("common.delete")}
                      </Button>
                    </Grid>
                  </Grid>
                ))}
              </Box>

              <LoadingButton
                loading={state.isLoading}
                fullWidth
                className="text-transform"
                variant="contained"
                style={{ marginTop: "10px" }}
                startIcon={<SendIcon />}
                type="submit"
              >
                Xác nhận
              </LoadingButton>
            </form>
          </div>
        </DialogContent>
      </Dialog>
      <DialogAttachmentManager
        isOpenDialogAttachment={state.is_open_dialog_file_manager}
        closeDialogAttachment={() =>
          setState((prev) => ({ ...prev, is_open_dialog_file_manager: false }))
        }
        cookie={cookies.is_login}
        // fanpage_id={fanpage_id}
        page_name="posts"
        imageSelectedOld={[]}
        imagePicked={updateImagePicked}
      />
    </React.Fragment>
  );
};

export default TrainingBotAIDialog;
